module.exports = __webpack_public_path__ + "static/img/iron 3.717f508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/iron 3.png
// module id = XuvQ
// module chunks = 35